/**
 * Puerta de entrada de las rutas privadas.
 *
 * Sin sesion no se renderiza ninguna pantalla: se manda al login guardando a
 * donde queria ir el usuario, para volver ahi despues de autenticarse. La
 * autorizacion real la hace la API en cada request; esto solo evita mostrar
 * pantallas que igual terminarian en 401.
 */
import type { ReactElement } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/auth-context';
import { AppShell } from './AppShell';
import { ErrorBanner } from './ErrorBanner';
import { LoadingBlock } from './Feedback';
import { MiddleMark } from './MiddleLogo';

export function RequireAuth(): ReactElement {
  const { status, error, refresh } = useAuth();
  const location = useLocation();

  if (status === 'checking') {
    return (
      <div className="auth-gate">
        <MiddleMark size={36} />
        <LoadingBlock label="Verificando la sesión…" />
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="auth-gate">
        <div className="auth-gate__card stack">
          <MiddleMark size={36} />
          <ErrorBanner error={error} onRetry={refresh} />
          <p className="muted">
            No se pudo resolver tu sesión contra la API del middleware. Si el problema persiste,
            revisa que el servicio esté arriba.
          </p>
        </div>
      </div>
    );
  }

  if (status === 'anonymous') {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <AppShell />;
}
